import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';

type Props = {
  className?: string;
  height?: number;
  /** A text-only string describing the icon if it's not purely decorative for accessibility */
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  title?: string | React.ReactElement<any>;
  width?: number;
};

const ImageTile = ({
  className = '',
  height = 44,
  title,
  width = 58,
}: Props) => (
  <AccessibleSVG
    className={`${className}`}
    height={height}
    title={title}
    viewBox="0 0 58 44"
    width={width}
  >
    <path
      clipRule="evenodd"
      d="M23.0192 20.4145L37.9088 35.7937L44.2784 27.9937C45.0368 27.0673 46.2704 27.0673 47.0384 27.9937L56.9264 39.9217C58.7024 42.0625 57.6896 43.8001 54.6608 43.8001H3.22398C0.185579 43.8001 -0.712021 42.1633 1.23678 40.1185L1.74078 39.5905L19.952 20.4913C20.816 19.5889 22.208 19.5793 23.024 20.4145H23.0192ZM36.2 0.600098C40.1744 0.600098 43.4 3.8257 43.4 7.8001C43.4 11.7745 40.1744 15.0001 36.2 15.0001C32.2256 15.0001 29 11.7745 29 7.8001C29 3.8257 32.2256 0.600098 36.2 0.600098Z"
      data-testid="image-icon"
      fill="#909090"
      fillRule="evenodd"
    />
  </AccessibleSVG>
);

export default ImageTile;
